/**
 * z-index.ts — 统一层级（z-index）管理
 * ────────────────────────────────────────
 * 所有 UI 组件的 z-index 集中定义于此，
 * 避免各组件各自为政导致层级冲突。
 *
 * 使用方式：
 *   import { Z } from "@/lib/z-index"
 *   <div style={{ zIndex: Z.MODAL_OVERLAY }}>
 *   className={`z-[${Z.NAV_PILL}]`}
 *
 * 层级规则：
 *   - 数值越大越靠前
 *   - 同一层级内若有多个元素，用 +1, +2 微调
 *   - Modal/Toast 等临时 UI 永远高于持久 UI（nav pill）
 */

export const Z = {
  /** 页面内容基础层 */
  BASE: 0,

  /** 装饰性元素（玻璃球、mesh 动画背景等） */
  DECORATION: 5,

  /** 普通浮动 UI（搜索栏等） */
  FLOAT: 10,

  /** 导航栏（顶部/底部固定导航） */
  NAV_BAR: 40,

  /** 浮动导航胶囊（nav pill） */
  NAV_PILL: 50,

  /** 弹窗遮罩层 */
  MODAL_OVERLAY: 60,

  /** 弹窗内容层 */
  MODAL_CONTENT: 61,

  /** 嵌套弹窗（从弹窗内打开的弹窗，如 InviteCode → Waitlist） */
  MODAL_NESTED: 70,

  /** Toast / Notification */
  TOAST: 80,

  /** 自定义光标（永远最顶层） */
  CURSOR: 9999,
} as const

export type ZLayer = keyof typeof Z
